import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  VisitorMeasureDrawerControlWrapper as BaseVisitorMeasureDrawerControlButton,
  VisitorMeasureDrawerControlMenuItemWrapper as BaseVisitorMeasureDrawerControlMenuItem,
} from '../../measures/VisitorMeasureDrawerControl';

export function VisitorMeetingMeasureDrawerControlButton({ className }: { className?: string }) {
  return (
    <BaseVisitorMeasureDrawerControlButton className={className} drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />
  );
}

export function VisitorMeetingMeasureDrawerControlMenuItem({ className }: { className?: string }) {
  return (
    <BaseVisitorMeasureDrawerControlMenuItem
      className={className}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
